import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Tooltip,
  Typography
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  Dashboard,
  Inventory2,
  MenuBook,
  Store,
  FileDownload,
  ListAlt,
  ShoppingCart
} from '@mui/icons-material';

const navItems = [
  { text: 'Dashboard', icon: <Dashboard />, to: '/confereai' },
  { text: 'Insumos', icon: <Inventory2 />, to: '/confereai/insumos' },
  { text: 'Receitas', icon: <MenuBook />, to: '/confereai/receitas' },
  { text: 'Fornecedores', icon: <Store />, to: '/confereai/fornecedores' },
  { text: 'Entradas', icon: <FileDownload />, to: '/confereai/entradas' },
  { text: 'Inventário', icon: <ListAlt />, to: '/confereai/inventario' },
  { text: 'Lista de Compras', icon: <ShoppingCart />, to: '/confereai/lista-compras' },
];

const Sidebar = ({ open }) => {
  const theme = useTheme();

  const navLinkStyles = ({ isActive }) => ({
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    ...(isActive && {
      backgroundColor: theme.palette.action.selected,
      '& .MuiListItemIcon-root': {
        color: theme.palette.primary.main,
      },
    }),
  });

  const DrawerHeader = () => (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', ...theme.mixins.toolbar }}>
      <Typography variant="h6" noWrap component="div" sx={{ opacity: open ? 1 : 0, transition: 'opacity 0.3s' }}>
        ConfereAI
      </Typography>
    </Box>
  );

  return (
    <>
      <DrawerHeader />
      <Divider />
      <List>
        {navItems.map((item) => (
          <Tooltip title={item.text} placement="right" key={item.text} disableHoverListener={open}>
            <ListItem disablePadding sx={{ display: 'block' }}>
              <NavLink to={item.to} style={navLinkStyles} end={item.to === '/confereai'}>
                <ListItemButton
                  sx={{
                    minHeight: 48,
                    justifyContent: open ? 'initial' : 'center',
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText primary={item.text} sx={{ opacity: open ? 1 : 0 }} />
                </ListItemButton>
              </NavLink>
            </ListItem>
          </Tooltip>
        ))}
      </List>
    </>
  );
};

export default Sidebar;

